module.exports = __webpack_public_path__ + "static/media/favourite-empty.26960eb8.svg";